import React from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';

const ADMIN_LVL_MASTER = 0;				// same as Users.js
const ADMIN_LVL_SEASONS = 3;
const ADMIN_LVL_SCORESHEETS = 10;

class RateSysAdmin_nav extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			season: this.props.season,
		};
	
		// this.dummyfunction = this.dummyfunction.bind(this);
	}

 	componentDidMount() {
		//console.log('RateSysAdmin_nav: componentDidMount');
		this.setState({
			season: this.props.season
		});		
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		//console.log('RateSysAdmin_nav: UNSAFE_componentWillReceiveProps');
		// console.log(nextProps);
		this.setState({
			season: nextProps.season
		});	
	}

  render() {
		// console.log('RateSysAdmin_nav: RENDER');
		// console.log(this.props.bRateSysExists);

		if ((this.props.adminAccess.adminValidatedAccessLevel <= ADMIN_LVL_SEASONS) && (this.props.bRateSysExists)) {
		return (
	    <div>
				<div className="row">
				<div className="col-md-12">
					<Link to="/admsafe/rateSys" className="btn btn-primary btnlink-green width175px btn-margin-right-20"> 
						Paramètres </Link>
					<Link to="/admsafe/rateSys/results" className="btn btn-primary btnlink-green width175px btn-margin-right-20">
						Résultats</Link>
					<Link to="/admsafe/rateSys/list" className="btn btn-primary btnlink-green width175px btn-margin-right-20">
						Listes complètes</Link>
				</div>
				</div>
				<br/>
	    </div>
	  );

		} else {
			return (<div></div>)
		}
  }

}

export default RateSysAdmin_nav;
